import React from 'react'
import {useLocation, useParams} from 'react-router-dom'
import {ServiceRattachementForm} from "./components/ServiceRattachementForm";
import {ModeleServiceRattachement} from "../../../components/Models";

type LocationState = {data: ModeleServiceRattachement | undefined | null}

const ServiceRattachementPage = () => {
  let {serviceRattachementId} = useParams()

  const location = useLocation()
  const state = location.state as LocationState

  return (
    <>
      <div className='card mb-5 mb-xl-10'>
        <div className='card-header border-0'>
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0'>
              {serviceRattachementId === undefined ? 'Créer' : 'Modifier'} un service de rattachement
            </h3>
          </div>
        </div>

        <div>
          <ServiceRattachementForm
            id={serviceRattachementId}
            data={state ? state.data : null}
          />
        </div>
      </div>
    </>
  )
}

export {ServiceRattachementPage}
